import type { TranslatedString } from "@web-monorepo/i18next";
import { DDSBodyText, DDSLabelText, DDSToggle } from "@web-monorepo/dds";
import { DevToolsSettings } from "./devToolsSettings";
import styles from "./ReactQuerySection.module.css";

export const ReactQuerySection = () => {
  const { reactQueryDevToolsEnabled, setReactQueryDevToolsEnabled } = DevToolsSettings.useReactQueryDevToolsEnabled();

  return (
    <div className={styles.root} disable-tag-translation>
      <div className={styles.sectionHeader}>
        <DDSLabelText>React Query DevTools</DDSLabelText>
      </div>
      <div className={styles.toggleRow}>
        <DDSBodyText level="md">{"Show React Query DevTools" as TranslatedString}</DDSBodyText>
        <DDSToggle
          checked={reactQueryDevToolsEnabled}
          onCheckedChange={setReactQueryDevToolsEnabled}
          size="small"
          data-name="dev_tools_react_query_toggle"
          aria-label={"Toggle React Query DevTools" as TranslatedString}
        />
      </div>
      <DDSBodyText level="sm" variant="secondary">
        {"When enabled, the React Query floating panel will appear on the page." as TranslatedString}
      </DDSBodyText>
    </div>
  );
};
